import {http} from "@/api/HttpClient.ts";
import {Pageable, PageModel} from "@/api/Paging.ts";
import {CampaignRole} from "@/auth/User.ts";
import {AdminUser, CampaignMember} from "@/admin/users/AdminUser.ts";

export async function searchAdminUsers(pageable: Pageable, query?: string): Promise<PageModel<AdminUser>> {
    const response = await http.get<PageModel<AdminUser>>("/admin/users", {params: {...pageable, query}});
    return response.data;
}

export async function getAdminUser(userId: string): Promise<AdminUser> {
    const response = await http.get<AdminUser>(`/admin/users/${userId}`);
    return response.data;
}

export async function getCampaignMembers(campaignId: string): Promise<CampaignMember[]> {
    const response = await http.get<CampaignMember[]>(`/admin/campaigns/${campaignId}/members`);
    return response.data;
}

export async function assignCampaignMember(campaignId: string, userId: string, role: CampaignRole): Promise<CampaignMember> {
    const response = await http.put<CampaignMember>(`/admin/campaigns/${campaignId}/members/${userId}`, {role});
    return response.data;
}

export async function removeCampaignMember(campaignId: string, userId: string): Promise<void> {
    await http.delete(`/admin/campaigns/${campaignId}/members/${userId}`);
}
